import { Component } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { PendingNewsService } from './pending-news.service';
import { DumbPendingNews } from './DTOs/dumb-pending-news';
import { merge, Observable } from 'rxjs';
import { GetPendingNewsListRequest } from './DTOs/get-pending-news-list-request'
import { PendingNewsDtRetInfo } from './DTOs/pending-news-dt-ret-info';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-pending-news',
  templateUrl: './pending-news.component.html',
  providers: [UIBlockingService, NgbDropdown]

})
export class PendingNewsComponent {
    constructor(private pendingNewsService: PendingNewsService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private router: Router) { }

    pendingNews: DumbPendingNews[] = [];
    totalNews = 0;
    filteredNews = 0;
    pageNum = 1;
    itemsPerPage = 10;
    initialLoad = true;
    filtersChanged = false;
    searchText = "";
    statusSearch = { display: "Pending", value: 0 };
    
    sortType = 1;
    keywordSearches: string[] = [];
    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPendingNews();
    }

    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }
    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.pendingNews.length;
    }


    ngOnInit() {
        var observablesMerged = merge(this.getPendingNewsObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.pendingNews = data.data;
                    this.totalNews = data.recordsTotal;
                    this.filteredNews = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                    if (this.pendingNews.length == 0) {
                        console.log(" no news found ")
                    }
                }
            });
    }

    getPendingNews() {
        this.blockUI.start();
        this.getPendingNewsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.pendingNews = data.data;
                        this.totalNews = data.recordsTotal;
                        this.filteredNews = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.pendingNews.length == 0) {
                            console.log(" no news found ")
                        }
                    }
                });
    }

    getPendingNewsObservable(): Observable<PendingNewsDtRetInfo> {
        var req = this.createSearchRequest();
        return this.pendingNewsService
            .getPendingNewsList(req);
    }

    createSearchRequest(): GetPendingNewsListRequest {
        var req = new GetPendingNewsListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSearch = this.statusSearch.value;

        this.filtersChanged = false;

        return req;
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter, 32 is space
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingNews();
        return;
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPendingNews();
    }

    clearSearch() {
        this.searchText = "";
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.statusSearch = { display: "Pending", value: 0 };
        this.getPendingNews();
    }
    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingNews();
    }


    changeSortType(column: number) {
        switch (column) {
            case 1:
                this.sortType = (this.sortType == 1) ? 2 : 1;
                break;
            case 2:
                this.sortType = (this.sortType == 3) ? 4 : 3;
                break;
            case 3:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 4:
                this.sortType = (this.sortType == 7) ? 8 : 7;
                break;
            default:
                break;
        }
        this.getPendingNews();
    }

    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case -1:
                this.statusSearch = { display: "All", value: -1 };
                break;
            case 0:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
            case 1:
                this.statusSearch = { display: "Approved", value: 1 };
                break;
            case 2:
                this.statusSearch = { display: "Denied", value: 2 };
                break;
            default:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
        }
        this.getPendingNews();
    }

}
